import {makeAutoObservable, reaction, when} from "mobx";
import * as Api from "api/api";
import {defaultAvatar} from "api/api";
import * as CookieUtil from "utils/CookieUtil";

class User {
    id = 0;
    username = "";
    avatar = "";
    nickname = "";
    gender = null;
    birthday = 0;
    token = "";

    constructor() {
        makeAutoObservable(this)

        this.token = CookieUtil.load('token')
    }


    setInfo(info) {
        const {id, username, avatar, nickname, gender, birthday} = info;

        this.id = id;
        this.username = username;
        this.avatar = avatar;
        this.nickname = nickname;
        this.gender = gender;
        this.birthday = birthday;
    }


    async login() {
        this.token = 'token';
        // await this.fetchInfo();
    }

    logout() {
        this.token = '';
        this.username = "";
        this.avatar = "";
        this.nickname = "";
        this.gender = null;
        this.birthday = 0;
    }

    async fetchInfo() {
        const {info} = await Api.userInfo();

        this.id = info.id;
        this.username = info.username;
        this.avatar = info.avatar;
        this.nickname = info.nickname;
        this.gender = info.gender;
        this.birthday = info.birthday;
    }

    get isLogin() {
        return !!this.token;
    }
}


const user = new User();

when(() => user.isLogin, async () => {
    await user.fetchInfo()
})

reaction(() => user.token, (value) => {
    CookieUtil.save('token', value)
})

reaction(() => user.avatar, (value) => {
    if (!value) {
        user.avatar = defaultAvatar
    }
}, {
    fireImmediately: true
})

export default user;
